/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Profile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Profile"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M10 8.667a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666m5 0a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M12.5 2a7.5 7.5 0 0 1 3.325 14.222A6.66 6.66 0 0 1 19.167 22H17.5a5 5 0 0 0-10 0H5.833a6.66 6.66 0 0 1 3.341-5.778A7.5 7.5 0 0 1 12.5 2m0 1.667a5.833 5.833 0 1 0 0 11.666 5.833 5.833 0 0 0 0-11.666"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const ProfileIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'profile-icon'}
      icon={Profile}
      {...props}
      size={size}
    />
  );
};
